const LEGACY_STORAGE_KEY = 'gbc.express.jointApplicantDraft'

export type ExpressJointApplicantBasicInfo = {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  agreeToTerms: boolean
}

export type ExpressJointApplicantDraft = ExpressJointApplicantBasicInfo & {
  dob: string
  ssn: string
  street: string
  apartment: string
  city: string
  state: string
  zip: string
  gender: string
  idNumber: string
  idState: string
  issueDate: string
  expirationDate: string
  idAddressMatches: string
  employmentStatus: string
  employerName: string
  jobTitle: string
  annualIncome: string
}

/** Removes legacy joint-applicant PII from sessionStorage (AO-302). */
export function clearExpressJointApplicantDraft(): void {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.sessionStorage.removeItem(LEGACY_STORAGE_KEY)
  } catch {
    // Non-fatal.
  }
}
